import { ISelectOptions, ITableConfigEntity } from '../../interfaces/internal-interfaces';
import { ExtDocument } from '../extDocument';
import { makeComplexConfigItem } from '../table-configs/table-config-helpers';

export function makeTimesheetManagerConfig(
  isNonbill: boolean,
  isPerDiem: boolean,
  isStormOrPrivate: boolean,
  approvers: ISelectOptions[],
): ITableConfigEntity<keyof ExtDocument>[] {
  const headerClasses = 'text-left pl-[5px]';
  const viewIconHeaderClasses = 'text-left pl-[8px]'; //makes the header text look centered

  if (isNonbill) {
    return [
      makeComplexConfigItem<ExtDocument>('Status', 'Status', 'status', 1, false, false, {
        headerClass: headerClasses,
        class: 'h-full',
      }),
      makeComplexConfigItem<ExtDocument>('Timesheet', 'Documentno', 'left-text', 2, false, true, {
        headerClass: headerClasses,
        class: 'h-full',
      }),
      makeComplexConfigItem<ExtDocument>('View', 'Link', 'icon', 1, false, false, {
        icon: 'print',
        shouldDetectClick: true,
        clickValue: 'showExtDoc',
        headerClass: viewIconHeaderClasses,
      }),
      makeComplexConfigItem<ExtDocument>('Owner', 'Owner', 'select', 2, false, true, {
        selectOptions: approvers,
        tooltip: 'Owner cannot be modified for nonbillable.',
        headerClass: headerClasses,
      }),
      makeComplexConfigItem<ExtDocument>('Description', 'Description', 'left-text', 5, false, true, {
        tooltip: 'Description cannot be modified for nonbillable.',
        minTextRows: 1,
        headerClass: headerClasses,
      }),
    ];
  } else if (isPerDiem) {
    return [
      makeComplexConfigItem<ExtDocument>('Status', 'Status', 'status', 1, false, false, {
        headerClass: headerClasses,
        class: 'h-full',
      }),
      makeComplexConfigItem<ExtDocument>('Timesheet', 'Documentno', 'left-text', 2, false, true, {
        headerClass: headerClasses,
        class: 'h-full',
      }),
      makeComplexConfigItem<ExtDocument>('View', 'Link', 'icon', 1, false, false, {
        icon: 'print',
        shouldDetectClick: true,
        clickValue: 'showExtDoc',
        headerClass: viewIconHeaderClasses,
      }),
      makeComplexConfigItem<ExtDocument>('Owner', 'Owner', 'select', 2, false, true, {
        selectOptions: approvers,
        tooltip: 'Owner cannot be modified for per diem.',
        headerClass: headerClasses,
      }),
      makeComplexConfigItem<ExtDocument>('Description', 'Description', 'left-text', 5, false, true, {
        tooltip: 'Description cannot be modified for per diem.',
        minTextRows: 1,
        class: 'pl-2',
        headerClass: headerClasses,
      }),
    ];
  } else if (isStormOrPrivate) {
    return [
      makeComplexConfigItem<ExtDocument>('', 'canDelete', 'icon', 1, false, false, {
        icon: 'delete',
        shouldDetectClick: false,
        clickValue: 'deleteClicked',
        tooltip: 'Timesheets with entries cannot be deleted',
      }),
      makeComplexConfigItem<ExtDocument>('Status', 'Status', 'status', 2, false, false, {
        class: '!text-left h-full',
        headerClass: headerClasses,
      }),
      makeComplexConfigItem<ExtDocument>('Timesheet', 'Documentno', 'left-text', 2, false, true, {
        headerClass: headerClasses,
        class: 'h-full',
      }),
      makeComplexConfigItem<ExtDocument>('View', 'Link', 'icon', 1, false, false, {
        icon: 'print',
        shouldDetectClick: true,
        clickValue: 'showExtDoc',
        headerClass: viewIconHeaderClasses,
      }),
      makeComplexConfigItem<ExtDocument>('Contract', 'contractDisplay', 'left-text', 3, false, true, {
        class: 'h-full !whitespace-pre-line !text-nowrap overflow-hidden', //make sure the line break in the contractDisplay property is respected, and that text does not wrap
        headerClass: headerClasses,
      }),
      makeComplexConfigItem<ExtDocument>('Owner', 'Owner', 'select', 3, false, false, {
        selectOptions: approvers,
        tooltip: 'The person who is responsible for approvals on this timesheet.',
        headerClass: headerClasses,
      }),
      makeComplexConfigItem<ExtDocument>('Description', 'Description', 'plain-button', 5, false, false, {
        tooltip: 'Controls how the timesheet will show throughout the application, but will not be visible to the customer.',
        minTextRows: 1,
        class: 'pl-2 !text-base',
        headerClass: headerClasses,
        clickValue: 'timesheetDescriptionEditClicked',
      }),
    ];
  } else {
    //Regular config: NOT NonBill, PerDiem, Storm, or Private
    return [
      makeComplexConfigItem<ExtDocument>('', 'canDelete', 'icon', 1, false, false, {
        icon: 'delete',
        shouldDetectClick: false,
        clickValue: 'deleteClicked',
        tooltip: 'Timesheets with entries cannot be deleted',
      }),
      makeComplexConfigItem<ExtDocument>('Status', 'Status', 'status', 2, false, false, {
        class: '!text-left h-full',
        headerClass: headerClasses,
      }),
      makeComplexConfigItem<ExtDocument>('Timesheet', 'Documentno', 'left-text', 2, false, true, {
        headerClass: headerClasses,
        class: 'h-full',
      }),
      makeComplexConfigItem<ExtDocument>('View', 'Link', 'icon', 1, false, false, {
        icon: 'print',
        shouldDetectClick: true,
        clickValue: 'showExtDoc',
        headerClass: viewIconHeaderClasses,
      }),
      makeComplexConfigItem<ExtDocument>('Contract', 'contractDisplay', 'left-text', 6, false, true, {
        class: 'h-full !whitespace-pre-line !text-nowrap overflow-hidden', //make sure the line break in the contractDisplay property is respected, and that text does not wrap
        headerClass: 'text-left',
      }),
      makeComplexConfigItem<ExtDocument>('Owner', 'Owner', 'select', 3, false, false, {
        selectOptions: approvers,
        tooltip: 'The person who is responsible for approvals on this timesheet.',
        headerClass: headerClasses,
      }),
      makeComplexConfigItem<ExtDocument>('Description', 'Description', 'plain-button', 5, false, false, {
        tooltip: 'Controls how the timesheet will show throughout the application, but will not be visible to the customer.',
        minTextRows: 1,
        headerClass: headerClasses,
        class: '!text-base',
        clickValue: 'timesheetDescriptionEditClicked',
      }),
    ];
  }
}
